import { Icon, Text } from 'AppStyles';
import { Container, Box, Button } from './Styles';
import reconnect from 'assets/svg/reconnect.svg';

const LoginSessionExpired = () => (
  <Container>
    <Box>
      <Text $weight={600}>One of two things happend:</Text>
      <Text>1. Too much time has passed since your last login.</Text>
      <Text>2. You are logged in somewhere else.</Text>
    </Box>
    <Box>
      <Text $weight={600}>You can not be logged in to the game and the store at the same time</Text>
      <Text>Please re-login to the store.</Text>
    </Box>
    <Button onClick={() => location.reload()}>
      Reconnect <Icon src={reconnect} width={13} />
    </Button>
  </Container>
);

export default LoginSessionExpired;
